import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL?.replace(/\/api\/?$/, '') || 'https://api.mercadointimo.com.br';

const CommentsManager = () => {
    const [comments, setComments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [replyModalOpen, setReplyModalOpen] = useState(false);
    const [selectedComment, setSelectedComment] = useState(null);
    const [replyText, setReplyText] = useState("");

    useEffect(() => {
        fetchComments();
    }, []);

    const fetchComments = async () => {
        try {
            const response = await axios.get(`${API_URL}/api/admin/comments`);
            setComments(response.data);
            setLoading(false);
        } catch (error) {
            console.error("Erro ao buscar comentários:", error);
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Tem certeza que deseja excluir este comentário?")) return;

        try {
            await axios.delete(`${API_URL}/api/comments/${id}`);
            fetchComments();
        } catch (error) {
            console.error("Erro ao deletar:", error);
            alert("Erro ao deletar comentário.");
        }
    };

    const openReplyModal = (comment) => {
        setSelectedComment(comment);
        setReplyText("");
        setReplyModalOpen(true);
    };

    const handleReplySubmit = async () => {
        if (!replyText.trim()) return;

        try {
            await axios.post(`${API_URL}/api/comments/${selectedComment.id}/reply`, {
                userId: 'admin',
                userName: 'Administrador',
                userPhoto: null,
                comment: replyText
            });

            setReplyModalOpen(false);
            fetchComments();
            alert("Resposta enviada com sucesso!");
        } catch (error) {
            console.error("Erro ao responder:", error);
            alert("Erro ao enviar resposta.");
        }
    };

    // Filtrar apenas comentários principais (não respostas) para a lista principal?
    // O requisito diz "TODOS os comentários". Mas respostas aninhadas na tabela podem ficar confusas.
    // Vamos listar tudo, mas indicar se é resposta.

    return (
        <div className="comments-manager">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h2>Gestão de Comentários</h2>
                <button onClick={fetchComments} className="btn btn-secondary">
                    <i className="fas fa-sync"></i> Atualizar
                </button>
            </div>

            {loading ? (
                <p>Carregando...</p>
            ) : (
                <div className="table-responsive">
                    <table className="table table-striped table-hover">
                        <thead>
                            <tr>
                                <th>Data</th>
                                <th>Autor</th>
                                <th>Comentário</th>
                                <th>Oferta</th>
                                <th>Status</th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {comments.map(comment => (
                                <tr key={comment.id} style={{ backgroundColor: comment.parentId ? '#f9f9f9' : 'white' }}>
                                    <td style={{ fontSize: '12px', whiteSpace: 'nowrap' }}>
                                        {new Date(comment.timestamp).toLocaleString()}
                                    </td>
                                    <td>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            {comment.userPhoto ? (
                                                <img src={comment.userPhoto} alt="" style={{ width: '30px', height: '30px', borderRadius: '50%' }} />
                                            ) : (
                                                <div style={{ width: '30px', height: '30px', borderRadius: '50%', background: '#ddd', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    {comment.userName.charAt(0)}
                                                </div>
                                            )}
                                            <div>
                                                <div style={{ fontWeight: 'bold', fontSize: '13px' }}>{comment.userName}</div>
                                                {comment.isAdminReply && <span className="badge badge-primary" style={{ fontSize: '10px' }}>ADMIN</span>}
                                            </div>
                                        </div>
                                    </td>
                                    <td style={{ maxWidth: '300px' }}>
                                        {comment.parentId && <span style={{ color: '#888', fontSize: '11px', display: 'block' }}>↳ Resposta</span>}
                                        {comment.comment}
                                    </td>
                                    <td>
                                        <a href={`http://localhost:3000/oferta/${comment.offerId}`} target="_blank" rel="noopener noreferrer">
                                            Ver Oferta
                                        </a>
                                    </td>
                                    <td>
                                        <span className={`badge badge-${comment.status === 'deleted' ? 'danger' : 'success'}`}>
                                            {comment.status || 'Ativo'}
                                        </span>
                                    </td>
                                    <td>
                                        <button
                                            onClick={() => openReplyModal(comment)}
                                            className="btn btn-sm btn-info"
                                            style={{ marginRight: '5px' }}
                                            title="Responder"
                                        >
                                            <i className="fas fa-reply"></i>
                                        </button>
                                        <button
                                            onClick={() => handleDelete(comment.id)}
                                            className="btn btn-sm btn-danger"
                                            title="Excluir"
                                        >
                                            <i className="fas fa-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {/* Modal de Resposta */}
            {replyModalOpen && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center',
                    zIndex: 1000
                }}>
                    <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '8px', width: '500px', maxWidth: '90%' }}>
                        <h3>Responder Comentário</h3>
                        <div style={{ backgroundColor: '#f5f5f5', padding: '10px', borderRadius: '4px', marginBottom: '15px', fontSize: '14px', fontStyle: 'italic' }}>
                            "{selectedComment?.comment}"
                        </div>

                        <div className="form-group">
                            <label>Sua Resposta:</label>
                            <textarea
                                className="form-control"
                                rows="4"
                                value={replyText}
                                onChange={(e) => setReplyText(e.target.value)}
                                placeholder="Digite sua resposta..."
                            ></textarea>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '15px' }}>
                            <button onClick={() => setReplyModalOpen(false)} className="btn btn-secondary">Cancelar</button>
                            <button onClick={handleReplySubmit} className="btn btn-primary">Enviar Resposta</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CommentsManager;
